// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label[for=default-quota-select][data-v-0a250c55]{display:block;padding:4px 0}`, "",{"version":3,"sources":["webpack://./apps/settings/src/components/Users/UserSettingsDialog.vue"],"names":[],"mappings":"AACA,iDACC,aAAA,CACA,aAAA","sourcesContent":["\nlabel[for=\"default-quota-select\"] {\n\tdisplay: block;\n\tpadding: 4px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
